import React from 'react'
import { Route } from 'react-router-dom'
import MainClientManagement from '../Views/Web/Client Management/MainClientManagement'
import { ClientCreate, ClientEdit, ClientView, ClinetMain, IndexClient } from '../Views/Web/Client Management/Clients'
import { ContractsCreate, ContractsEdit, ContractsMain, ContractsView, EquipmentsContract, FormContract, IndexContract, InspectionContract, InvoiceContract, ServiceContract } from '../Views/Web/Client Management/Contracts'
import { SurveyReportCreate, SurveyReportEdit, SurveyReportsView, SurveyReportMain, IndexSurveyReport, ViewForm } from '../Views/Web/Client Management/SurveyReport'
import Contracts from '../Views/Web/Client Management/Clients/Contracts'
import Inspection from '../Views/Web/Client Management/Clients/Inspection'
import Equipments from '../Views/Web/Client Management/Clients/Equipments'
import Service from '../Views/Web/Client Management/Clients/Service'
import Invoice from '../Views/Web/Client Management/Clients/invoice'

function ClientManagementRoutes() {
    return (
      <Route path="client-management" element={<MainClientManagement />}>
          {/* <Route path="clients" element={<ClinetMain/>} >
           <Route index element={<IndexClient/>} />
           <Route path='create' element={<ClientCreate/>} />
           <Route path='edit/:clientEditId' element={<ClientEdit/>} />
           <Route path='view/:clientViewId' element={<ClientView/>} />
           <Route path='contracts/:clientViewId' element={<Contracts/>} />
           <Route path='inspection/:clientViewId' element={<Inspection/>} />
           <Route path='equipments/:clientViewId' element={<Equipments/>} />
           <Route path='service/:clientViewId' element={<Service/>} />
           <Route path='invoice/:clientViewId' element={<Invoice/>} />
          </Route> */}
         <Route path="survey-report" element={<SurveyReportMain/>} >
           <Route index element={<IndexSurveyReport/>} />
           <Route path='create' element={<SurveyReportCreate/>} />
           <Route path='edit/:surveyReportEditId' element={<SurveyReportEdit/>} />
           <Route path='view/:surveyReportViewId' element={<SurveyReportsView/>} />
           <Route path='form/:surveyReportViewId' element={<ViewForm/>} />

          </Route>
         
          <Route path="contracts" element={<ContractsMain/>} >
           <Route index element={<IndexContract/>} />
           <Route path='create' element={<ContractsCreate/>} />
           <Route path='edit/:contractsEditId' element={<ContractsEdit/>} />
           <Route path='view/:contractsViewId' element={<ContractsView/>} />
           <Route path='form/:contractsViewId' element={<FormContract/>} />
           <Route path='equip/:contractsViewId' element={<EquipmentsContract/>} />
           <Route path='inspection/:contractsViewId' element={<InspectionContract/>} />
           <Route path='invoice/:contractsViewId' element={<InvoiceContract/>} />
           <Route path='service/:contractsViewId' element={<ServiceContract/>} />



          </Route>
          
      </Route>
    )
  }
  
  export default ClientManagementRoutes